import React from 'react';

const EnvironmentDeletedEvent = (props) => (
  <span>Environment <em>{props.environmentName}</em> deleted by {props.userEmail}</span>
);

export default EnvironmentDeletedEvent;
